/**
 * This function calls:
 * - `/login` for local development
 * - `/login/ldap` for production
 *
 * When calling `/login/ldap` in production, this function always throws an error due
 * to bad redirect (to http instead of https). However, the login might be successful.
 */
export async function loginUser(
  username: string,
  password: string,
  env: string
) {
  const isProduction = env === 'production';

  const response = fetch(`/api/tapis/login${isProduction ? '/ldap' : ''}`, {
    headers: new Headers({
      'Content-Type': 'application/json',
      ...(isProduction && {
        Authorization: `Basic ${btoa(`${username}:${password}`)}`,
      }),
    }),
    method: 'POST',
    ...(!isProduction && {
      body: JSON.stringify({ username, password }),
    }),
  });

  return await response;
}
